import { AxiosResponse } from 'axios';
import { api } from 'services/companiesApi';

export const getHRAGroups = async (): Promise<AxiosResponse> => {
	return await api.get('/hra/groups');
};

export const getHraGroupsEmployees = async (
	filters: any,
): Promise<AxiosResponse> => {
	return await api.get('/hra/employees', {
		params: filters,
	});
};

export const getPopulationActions = async (
	hraGroupCompanyId: string,
	employeeId: string,
): Promise<AxiosResponse> => {
	return await api.get(
		`/hra/employees/actions?hraGroupCompanyId=${hraGroupCompanyId}&employeeId=${employeeId}`,
	);
};
